<script lang="ts">
import { InputNumber } from 'element-ui';
export default InputNumber;
</script>
